import { Component } from '@angular/core';
import { NavController, NavParams ,AlertController } from 'ionic-angular';
import {CartPage} from "../cart/cart";
import {CreateCustomerPage} from "../create-customer/create-customer";
import {EditCustomerPage} from "../edit-customer/edit-customer";

import 'rxjs/add/operator/map';

// Operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';

import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise'


// Add the RxJS Observable operators we need in this app.
// import './rxjs-operators';


import {ItemsPage} from "../items/items";
import {Api} from "../../providers/api";
import {ApiOffline} from "../../providers/api-offline";
import {CartManager} from "../../providers/cart-manager";

import { GVLogger } from '../../services/gv-logger';
import { Headers , RequestOptions } from '@angular/http';

import { IMAGES_BASE_URL ,ApplicationVariables } from "../../providers/config";
import {CATEGORIESnTAGS, Customer, loginUserInfo} from "../../providers/data";


import { ImageLoader } from 'ionic-image-loader';

import {ComingSoon} from "../coming-soon/coming-soon";

import { MsgManager } from '../../providers/msg-manager';
import {LoginPage} from '../login/login';

import { DatabaseProvider } from '../providers/database/database';
import {isIntelliStock} from "../../providers/config";


@Component({
  selector: 'page-search-customers',
  templateUrl: 'search-customers.html'
})
export class SearchCustomersPage {
private showList: boolean;
private customers:any = [];
private searchQuery:any;
private items:any =[];
private imagesURLs:string[] = [];
private imagesLoaded:boolean = false;
private callCompleted:boolean = true;

// initially true
isMoredata = true;
isOfflineMode:any = false;
  offlinecustomers: any;
  isIntelliStockfunc = isIntelliStock;
  countryCodes = [];


    constructor(public nav: NavController,
    public navParams: NavParams,
    public api:Api,
    private apiOffline:ApiOffline,
    private cartManager:CartManager,
    private alertCtrl:AlertController,
    private imageLoader:ImageLoader,
    private gVLogger:GVLogger,
    private msgManager:MsgManager,
    ) {

      this.isOfflineMode = ApplicationVariables.isOffline;

     //this.preLoadImages();

    // alert("Search customers isOfflineMode true or false: "+  this.isOfflineMode);

    this.showList = true;
    this.searchQuery = "";
    this.searchCustomersResolver(this.searchQuery,0);
    // this.initializeCustomers();
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad SearchCustomersPage');
  }
 // view cart
  goToCart() {
    this.nav.push(CartPage);
  }
 //  View goToCreateCustomer
   goToCreateCustomer(){
   this.nav.push(CreateCustomerPage);
   }

  // view a category
  viewCategory() {
    this.nav.push(ItemsPage);
  }

  searchThroughItems(ev: any){
    // Reset items back to all of the items
    // this.initializeCustomers();
    this.gVLogger.log(ev.target.value);
    // Show the results
    this.showList = true;
// set val to the value of the searchbar
    let val = ev.target.value;

    this.isMoredata = true;

    if(ev.target.value!=""){
      this.searchQuery = val;
      this.customers = [];
      this.searchCustomersResolver(this.searchQuery,0)
      }else{
        this.searchQuery = "";
      this.customers = [];
      this.searchCustomersResolver(this.searchQuery,0)
      //this.searchCustomersLazy(this.searchQuery,0);
      }


    }



    searchCustomersResolver(query,offset){
      return new Promise((resolve)=>{
        if( ApplicationVariables.isOffline){
         resolve(this.searchCustomersLazyOffline(query,offset));
        }else{
          resolve(this.searchCustomersLazy(query,offset));
        }

        //alert("inside search customer resolver");
      });
    }



    searchCustomersLazyOffline(query,offset){
      // alert("lazy offline called...");

      return new Promise((resolve)=>{
        // alert("enter in  resolve lazy load..!!");
        // if(query === undefined || query === "")
        // {
        //   query = '%20%';
        //    this.gVLogger.log('searchQuery value set as empty ---- ');
        // }
        let url = "customers/search/" + query + "/" + offset;

        var response1 = this.apiOffline.get(url).then(result => {

          // alert("enter in offline responce" + result.rows.length);

          let response:any = {
              status:200,
              message:"",
              data:[]
            };

            response.status = 200;
            response.message = "Offline Records";

            for(var i=0; i<result.rows.length; i++)
            {
                var json = JSON.parse(result.rows.item(i).json);
                response.data.push(json);
              //  alert(result.rows.item(i).json);
            }

            if(result.rows.length <=0){
              this.isMoredata = false;
            }

          //  alert(JSON.stringify(response));
           this.populateData(response);
           resolve(true);
        })
        .catch(e => {
          // alert("caught: "+JSON.stringify(e))
          resolve(true);
        });
      });



    }



populateData(response){

  let temp = this.customers;

  for(let cust of response.data){
           // this.gVLogger.log(cust);
            temp.push(cust);
          }
          this.customers  = this.arrayUnique(temp);
}



  onCancel(ev) {
    ev.target.value = '';
    this.searchQuery = "";
    this.isMoredata = true;
      this.customers = [];
      this.searchCustomersResolver(this.searchQuery,0);
  }


viewItemsList(customer){
  // alert("viewItemsList");
  Customer.id = customer.id

  if(ApplicationVariables.isOffline){

     this.gotoItemsPage(customer);
  }else{

    this.api.get("customers/"+ customer.id).map(res => res.json()).subscribe(result => {
    if(result.status == "200"){
      customer = result.data;
      Customer.paymentCurrency = result.data.paymentCurrency

       this.gotoItemsPage(customer);
   }else if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
  });

  }

}


gotoItemsPage(customer){

        this.gVLogger.log("CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC " + JSON.stringify(customer))

    for(let loc of customer.locationsDTOs){
        this.gVLogger.log("location dto " + JSON.stringify( loc));
        if(loc.locationType === "SHIPTO" || loc.locationType === "BILLTOSHIPTO") {
            loginUserInfo.customerShippingCost = loc.shippingCost;
        }
    }
  let cartCustomerName = "  ";

        if(this.cartManager.getCustomerName()!= null){
          cartCustomerName = this.cartManager.getCustomerName();
        }
        if(this.cartManager.getCustomerID()){
        // this.gVLogger.log("Full customer Object : ");
        // this.gVLogger.log(customer);
        // this.gVLogger.log("cart customer id : ");
        // this.gVLogger.log(this.cartManager.getCustomerID());
          if(this.cartManager.getCustomerID() == customer.id){
        // this.gVLogger.log("Same Customer as last ");

           // this.cartManager.setCustomer(customer);

             this.nav.setRoot(ItemsPage);

            return;
          }
        }


        if(this.cartManager.getProductsCount() > 0 ){

        let confirm = this.alertCtrl.create({
               title: 'Unsaved cart found.',
              message: "Customer: '"+ cartCustomerName +"'. What would you like to do?",
              buttons: [
                {
                  text: 'Go to old cart',
                  handler: () => {
                    this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
                  }
                },
                {
                  text: 'Replace with new cart',
                  handler: () => {
                   this.cartManager.setOrderTitle("");
                   this.cartManager.setCustomer(customer);
                   this.cartManager.setOrderMessage("");
                   this.cartManager.setShipDate("");
                   this.nav.setRoot(ItemsPage);
                  }
                }
              ]
            });
            confirm.present();
        }else{
          this.cartManager.setCustomer(customer);
        //alert(JSON.stringify(customerId));
        this.cartManager.setOrderMessage("");
        this.cartManager.setShipDate("");
        this.nav.setRoot(ItemsPage);
        }
}

searchCustomersLazy(searchQuery,itemCount){

  return new Promise(resolve => {


   this.gVLogger.log(url);
  //  get list items of a category as sample
  this.gVLogger.log("serach query ===="+ "-"+ searchQuery+ '-');
  if(searchQuery === undefined || searchQuery === "")
  {
    searchQuery = '%20';
    this.gVLogger.log('searchQuery value set as empty ---- ');
  }


    var url = "customers/search/"+searchQuery+"/"+itemCount;
    this.gVLogger.log('UD -----  url ----'+ url);
   this.api.get(url).map(res => res.json())
   .subscribe(data => {

      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
        resolve(true);
      }else{

          this.gVLogger.log(data);


          if(!(typeof data === 'undefined') && data){
              if (data.data && data.data.constructor === Array) {

              } else {
                data.data = [];
              }
            }else{
              data = { data: []};
            }

            if(data.data.length <=0){
              this.isMoredata = false;
            }

            this.populateData(data);


          resolve(true);
      }

      },err=>{
        this.gVLogger.log("front Error: "+err);
      });
    });
}

editCusomer(customer){
  // alert("editcustomers page");
  this.nav.push(EditCustomerPage,{"customerMinimized": customer});
}

doInfinite(infiniteScroll){
     this.searchCustomersResolver(this.searchQuery,this.customers.length).then(()=>{
       infiniteScroll.complete();
       this.gVLogger.log("infiniteScroll.complete()");
     });


}



arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i].id === a[j].id)
                a.splice(j--, 1);
        }
    }

    return a;
}





  goToComingSoon(){
  // this.nav.push(ComingSoon);
  this.nav.push(CreateCustomerPage);
}

getAllOfflineCustomers(){


   this.offlinecustomers = this.apiOffline.offlineCustomers;

  //  alert("Getting DATA" + this.offlinecustomers);
  // .then((res)=>{
  //   alert(JSON.stringify(res));
  // },err=>{
  //   alert(JSON.stringify(err));
  // })
}



}



// WEBPACK FOOTER //
// ./src/pages/search-customers/search-customers.ts